import CountryCode from "components/select/countryCode";
import { useAuthContext } from "components/context/authContext";
import JoinBtnWrap from "../../btnWrap";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useJoinContext } from "components/context/joinContext";
import { numRegex, successControl } from "util/commAction";
import { useMutation } from "@tanstack/react-query";
import { confirmApi, loginApi } from "components/api/user";
import { useTranslation } from "react-i18next";
import "./info.scss";

export default function Info() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { viewPort } = useAuthContext();
  const { joinInf } = useJoinContext();
  const { lodInf, setIsLogin } = useAuthContext();

  const [inf, setInf] = useState({
    fstnm: joinInf?.fstnm ?? "",
    surnm: joinInf?.surnm ?? "",
    mobCntyCd: joinInf?.mobCntyCd ?? "+82",
    mobNo: joinInf?.mobNo ?? "",
  });

  //로그인
  const loginMutation = useMutation({
    mutationFn: loginApi,
    onSuccess: (res, variables) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            navigate("/" + (lodInf?.lodNo ?? ""));
            setIsLogin(true);
            sessionStorage.setItem("isLogin", "true");
            localStorage.setItem(
              "userInf",
              JSON.stringify({
                ...res.data,
                emlId: variables,
              })
            );
          },
        });
      }
    },
  });

  const handleChange = (name: string, value: string) => {
    setInf({
      ...inf,
      [name]: value,
    });
  };

  //회원가입
  const joinMutation = useMutation({
    mutationFn: confirmApi,
    onSuccess: (res, variables) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            //로그인 하기
            loginMutation.mutate({
              emlId: variables.emlId,
              lgnPwd: variables.lgnPwd,
            });

            localStorage.removeItem("joinInf");
          },
        });
      }
    },
  });

  const handleNext = () => {
    const params = {
      ...joinInf,
      ...inf,
    };

    joinMutation.mutate(params);
  };

  const isAble = Object.values(inf).every((value) => !!value);

  return (
    <div className={"join" + " " + viewPort?.screen + " " + "min-h-[464px]"}>
      <form className="info">
        <div className="">
          <label htmlFor="" className="text-left w-full">
            {t("lbl_nm_cmm")}
          </label>
          <div className="flex gap-2">
            <input
              type="text"
              placeholder={t("plchl_s_nm_cmm")}
              name="fstnm"
              onChange={(e) => handleChange("fstnm", e.currentTarget.value)}
            />
            <input
              type="text"
              placeholder={t("plchl_f_nm_cmm")}
              name="surnm"
              onChange={(e) => handleChange("surnm", e.currentTarget.value)}
            />
          </div>
        </div>
        <div className="mt-[1.5rem]">
          <label htmlFor="">{t("lbl_ph_nm_cmm")}</label>
          <div className="flex gap-2">
            <CountryCode styles="" name="memMobCntyCd" />
            <input
              type="text"
              placeholder={t("plchl_nm_cmm")}
              name="mobNo"
              value={inf.mobNo}
              onChange={(e) => {
                const value = e.currentTarget.value;
                if (!numRegex.test(value)) {
                  return;
                }
                handleChange("mobNo", value);
              }}
            />
          </div>
        </div>
      </form>
      <JoinBtnWrap
        disabled={!isAble}
        btnTxt="btn_cmp_sng"
        handleNext={handleNext}
      />
    </div>
  );
}
